import { apiClient } from './api';

export interface LexBotConfig {
  botId: string;
  botAliasId: string;
  botVersion: string;
  botLocaleId: string;
  botArn: string;
  aliasArn: string;
  status: string;
  lastUpdatedAt: string;
  custom_lex_enabled?: boolean;
}

export interface BotVersion {
  version: string;
  createdAt: string;
}

export const lexBotApi = {
  async createBot(tenantId: string) {
    const response = await apiClient.post(`/admin/tenant/${tenantId}/lex-bot`);
    return response.data;
  },

  async getBot(tenantId: string): Promise<LexBotConfig | null> {
    try {
      const response = await apiClient.get(`/admin/tenant/${tenantId}/lex-bot`);
      // Response can be {data: {config: {...}}} or {config: {...}} or {data: {...}}
      const data = response?.data || response;
      return data?.config || data || null;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  async deleteBot(tenantId: string) {
    await apiClient.delete(`/admin/tenant/${tenantId}/lex-bot`);
  },

  async enableBot(tenantId: string) {
    const response = await apiClient.post(`/admin/tenant/${tenantId}/lex-bot/enable`);
    return response.data;
  },

  async disableBot(tenantId: string) {
    const response = await apiClient.post(`/admin/tenant/${tenantId}/lex-bot/disable`);
    return response.data;
  },

  async listVersions(tenantId: string): Promise<BotVersion[]> {
    try {
      const response = await apiClient.get(`/admin/tenant/${tenantId}/lex-bot/versions`);
      const data = response?.data || response;
      return data?.versions || [];
    } catch (error) {
      console.error('listVersions error:', error);
      return [];
    }
  },

  async publishVersion(tenantId: string) {
    const response = await apiClient.post(`/admin/tenant/${tenantId}/lex-bot/publish`);
    return response.data;
  },

  async setAlias(tenantId: string, aliasName: string, version: string | number) {
    const response = await apiClient.post(`/admin/tenant/${tenantId}/lex-bot/alias`, {
      aliasName,
      version: String(version)
    });
    return response.data;
  },

  async getIntents(tenantId: string) {
    const response = await apiClient.get(`/admin/tenant/${tenantId}/lex-bot/intents`);
    const data = response?.data || response;
    return data?.intents || [];
  },

  async addUtterance(tenantId: string, intentId: string, utterance: string) {
    const response = await apiClient.post(`/admin/tenant/${tenantId}/lex-bot/intents/${intentId}/utterances`, {
      utterance
    });
    return response.data;
  },

  async removeUtterance(tenantId: string, intentId: string, utterance: string) {
    const response = await apiClient.post(`/admin/tenant/${tenantId}/lex-bot/intents/${intentId}/utterances/remove`, {
      utterance
    });
    return response.data;
  },

  async copyIntents(tenantId: string) {
    const response = await apiClient.post(`/admin/tenant/${tenantId}/lex-bot/copy-intents`);
    return response.data;
  },

  async createLocale(tenantId: string) {
    const response = await apiClient.post(`/admin/tenant/${tenantId}/lex-bot/create-locale`);
    return response.data;
  }
};
